import { useLocales } from 'src/contexts'

import { useManageFuelHistory } from 'src/hooks/useManageFuelHistory'

export const useSetting = () => {
  const { translations } = useLocales()

  const { allFuelHistory, isLoadingGetAllFuelHistory } = useManageFuelHistory()

  const breadcrumbItems = [
    { labelKey: translations.breadcrumbItems.home, href: '/' },
    {
      labelKey: translations.breadcrumbItems.serviceContacts,
      href: '/service/history',
    },
    { labelKey: translations.breadcrumbItems.history },
  ]

  return {
    settingLabel: translations.setting.setting,
    breadcrumbItems,
    isLoadingGetAllFuelHistory,
    allFuelHistory,
  }
}
